function n(i){return!i||typeof i!="string"?i:i.split(" ").map(e=>e.charAt(0).toUpperCase()+e.slice(1)).join(" ")}export{n as a};
